import { render } from "./CSpinner.vue?vue&type=template&id=5d1b0bf9"
import script from "./CSpinner.vue?vue&type=script&lang=js"
export * from "./CSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__